import { IAppState, TActions } from '../../common/state';
import { jq } from '../../json_query';
import { FOfferType } from '../../utils/category';

export interface IOfferTypeChangedAction {
  type: 'filters/offer_type/OFFER_TYPE_SELECTED';
  offerType: FOfferType;
}

export function selectOfferType(offerType: FOfferType): IOfferTypeChangedAction {
  return {
    type: 'filters/offer_type/OFFER_TYPE_SELECTED',
    offerType,
  };
}

export function offerTypeReducer(state: IAppState, action: TActions): IAppState {
  const jsonQuery = jq(state.filters.jsonQuery);

  switch (action.type) {
    case 'filters/offer_type/OFFER_TYPE_SELECTED':
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: jsonQuery.selectOfferType(action.offerType),
        },
      };
    default:
      return state;
  }
}
